import { Component, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { PageModel } from '../Inbuilt-report-model';

@Component({
  selector: 'app-inbuilt-pages-v2',
  standalone: false,
  templateUrl: './inbuilt-pages-v2.component.html',
  styleUrl: './inbuilt-pages-v2.component.css'
})
export class InbuiltPagesV2Component implements OnChanges {
  selectedPage : PageModel | null = null;
  @Input() pages: Array<PageModel> = [];
  @Input() currentSelectedPage: PageModel | null = null;
  @Output() pageChange: EventEmitter<PageModel> = new EventEmitter();

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle external page selection (from navigateToPage)
    if (changes['currentSelectedPage'] && this.currentSelectedPage) {
      this.selectedPage = this.currentSelectedPage;
      return;
    }
    
    if (changes['pages'] && this.pages.length > 0) {
      const selectedStillExists = this.selectedPage
        ? this.pages.some((page) => page.name === this.selectedPage?.name)
        : false;

      this.selectedPage = selectedStillExists ? this.selectedPage : this.pages[0];
      // if (this.selectedPage) {
      //   this.pageChangeEmitter.emit(this.selectedPage);
      // }
    }
  }

  onPageChange(page: PageModel) {
    this.selectedPage = page;
    console.log('Selected Page:', this.selectedPage);
    this.pageChange.emit(page);
  }
}
